module.exports = __webpack_public_path__ + "img/373.a6b17b48.jpg";